import { z } from 'zod';
import { DecimalLikeSchema, IsoDateTimeSchema, PaginationSchema, UuidSchema } from './common.js';
export const VehiculoSchema = z.object({
    id: UuidSchema,
    marca: z.string().max(100).nullable(),
    modelo: z.string().max(100).nullable(),
    patente: z.string().min(1).max(20),
    estado: z.string().max(50).nullable(),
    combustibleNivel: z.number().int().nullable(),
    consumoPromedio: DecimalLikeSchema.nullable(),
    usoMes: DecimalLikeSchema.nullable(),
    gastoMes: DecimalLikeSchema.nullable(),
    imagenUrl: z.string().max(1000).nullable(),
    responsableId: UuidSchema.nullable(),
    responsableNombre: z.string().max(200).nullable(),
    sucursalId: UuidSchema.nullable(),
    createdAt: IsoDateTimeSchema.nullable(),
});
export const CreateVehiculoRequestSchema = z.object({
    patente: z.string().min(1).max(20),
    marca: z.string().max(100).nullable().optional(),
    modelo: z.string().max(100).nullable().optional(),
    estado: z.string().max(50).nullable().optional(),
    combustibleNivel: z.number().int().nullable().optional(),
    consumoPromedio: DecimalLikeSchema.nullable().optional(),
    usoMes: DecimalLikeSchema.nullable().optional(),
    responsableId: UuidSchema.nullable().optional(),
    responsableNombre: z.string().max(200).nullable().optional(),
    sucursalId: UuidSchema.nullable().optional(),
});
export const UpdateVehiculoRequestSchema = z.object({
    patente: z.string().min(1).max(20).optional(),
    marca: z.string().max(100).nullable().optional(),
    modelo: z.string().max(100).nullable().optional(),
    estado: z.string().max(50).nullable().optional(),
    combustibleNivel: z.number().int().nullable().optional(),
    consumoPromedio: DecimalLikeSchema.nullable().optional(),
    usoMes: DecimalLikeSchema.nullable().optional(),
    responsableId: UuidSchema.nullable().optional(),
    responsableNombre: z.string().max(200).nullable().optional(),
    sucursalId: UuidSchema.nullable().optional(),
});
export const VehiculoListQuerySchema = PaginationSchema.extend({
    estado: z.string().max(50).optional(),
});
// Shape mínimo p/ dropdowns cross-módulo (F9): qualquer autenticado resolve
// id→label; sem responsável, sucursal, nível ou consumo. Consumido por Finanzas
// (transacción de combustible) sem exigir o módulo flota.
export const VehiculoOptionSchema = z.object({
    id: UuidSchema,
    patente: z.string(),
    marca: z.string().nullable(),
    modelo: z.string().nullable(),
});
export const GastoCombustibleSchema = z.object({
    id: UuidSchema,
    vehiculoId: UuidSchema.nullable(),
    monto: DecimalLikeSchema,
    litros: DecimalLikeSchema.nullable(),
    kilometraje: z.number().int().nullable(),
    estacion: z.string().max(200).nullable(),
    fecha: IsoDateTimeSchema.nullable(),
    createdAt: IsoDateTimeSchema.nullable(),
});
export const CreateGastoCombustibleRequestSchema = z.object({
    monto: DecimalLikeSchema,
    vehiculoId: UuidSchema.nullable().optional(),
    litros: DecimalLikeSchema.nullable().optional(),
    kilometraje: z.number().int().nullable().optional(),
    estacion: z.string().max(200).nullable().optional(),
    fecha: IsoDateTimeSchema.optional(),
});
export const UpdateGastoCombustibleRequestSchema = z.object({
    monto: DecimalLikeSchema.optional(),
    vehiculoId: UuidSchema.nullable().optional(),
    litros: DecimalLikeSchema.nullable().optional(),
    kilometraje: z.number().int().nullable().optional(),
    estacion: z.string().max(200).nullable().optional(),
    fecha: IsoDateTimeSchema.optional(),
});
export const GastoCombustibleListQuerySchema = PaginationSchema.extend({
    vehiculoId: UuidSchema.optional(),
    from: IsoDateTimeSchema.optional(),
    to: IsoDateTimeSchema.optional(),
});
export const FlotaStatsSchema = z.object({
    total: z.number().int(),
    operativos: z.number().int(),
    mantenimiento: z.number().int(),
    consumoEstimado: DecimalLikeSchema,
});
export const CombustibleStatsSchema = z.object({
    totalGasto: DecimalLikeSchema,
    totalLitros: DecimalLikeSchema,
    costoPromedioLitro: DecimalLikeSchema,
    serieMensual: z.array(z.object({ mes: z.string(), monto: DecimalLikeSchema })),
    topConsumo: z.array(z.object({
        vehiculoId: UuidSchema.nullable(),
        patente: z.string().nullable(),
        monto: DecimalLikeSchema,
    })),
});
//# sourceMappingURL=flota.js.map